import React from "react";
import { Message } from "components/Atoms/Message";
import { Button } from "semantic-ui-react";
import { uploadFileToCoreApi } from "utilities/fileUploadUtils";
import { type Line, type SignType } from "../../eSignLanding/drawing/models";
import SigningCanvas from "../../eSignLanding/drawing/SigningCanvas";
import UploadedSignatureFile from "./UploadedSignatureFile";

interface Props {
  signType: SignType
  setSignType: (signType: SignType) => void
  signatureLines: Line[]
  setSignatureLines: (lines: Line[]) => void
  uploadedFile: string
  setUploadedFile: (file: string) => void
  uploadError: string
  setUploadError: (error: string) => void
  hasEmptySignature: boolean
  svgRef: React.RefObject<SVGSVGElement>
}

const SignatureSelection = (props: Props) => {
  const { signType, setSignType, signatureLines, setSignatureLines, uploadedFile, setUploadedFile, uploadError, setUploadError } = props;

  const displayDrawingCanvas = signType === "draw" || (signType === "imageFile" && uploadedFile == null);
  const fileRef = React.useRef<HTMLInputElement>(undefined);

  const selectDrawSignature = () => {
    if (signType === "draw") return;
    setSignType("draw");
    setSignatureLines([]);
    setUploadError(undefined);
  };

  const fileRemoved = () => {
    setUploadedFile(undefined);
    setUploadError(undefined);
    setSignatureLines([]);
    setSignType("draw");
  };

  const onFileSelected: React.ChangeEventHandler<HTMLInputElement> = async (e) => {
    setUploadError(undefined);
    const file = e.target.files[0];
    if (!file) return;

    const res = await uploadFileToCoreApi(
      window.CoreApi.UserSignature.UploadSignatureFile,
      window.CoreApi.UserSignature.UploadSignatureFile.absoluteUrl(),
      { file },
      { fileType: "image" }
    );
    if (res.data.hasErrors) {
      setUploadError(res.data.errors[0].message);
      return;
    }
    setUploadedFile(res.data.data.fileId);
    setSignType("imageFile");
  };

  return <>
    <div className="margin-bottom" style={{ width: 480 }}>
      <Button.Group fluid>
        <Button
          primary
          type="button"
          onClick={selectDrawSignature}
          active={displayDrawingCanvas}>
          {RESX.ESignLanding.btnDraw}

        </Button>
        <Button
          className="blue"
          type="button"
          onClick={() => { fileRef.current.click(); }}
          active={!displayDrawingCanvas}>
          {RESX.ESignLanding.btnImage}
        </Button>
      </Button.Group>
    </div>

    {uploadError && <Message type="error" className="margin-bottom">
      {uploadError}
    </Message>}

    <div style={{ width: 480 }}>
      {displayDrawingCanvas && <div className="margin-bottom-small">
        <SigningCanvas
          lines={signatureLines}
          onLinesChanged={setSignatureLines}
          error={props.hasEmptySignature}
          svgRef={props.svgRef}
          width={480}
        />
        <div className="margin-top-small flex justify-center" >
          <div className="">
            <a onClick={() => { setSignatureLines([]); }}>{RESX.GeneralLabels.clear}</a>
          </div>
        </div>
      </div>}
      {!displayDrawingCanvas && <div className="margin-bottom-small">
        <UploadedSignatureFile
          fileId={uploadedFile}
          clearButtonAlign="center"
          onFileRemoved={fileRemoved}
        />
      </div>}
    </div>

    <input ref={fileRef} type="file" accept="image/*" onChange={onFileSelected} style={{ display: "none" }} />
  </>;
};

export default SignatureSelection;